module.exports = __webpack_public_path__ + "static/media/karch_logo.638c98c5.png";